import { render, staticRenderFns } from "./account-company-individual-quota-widget.vue?vue&type=template&id=43e0584b&"
import script from "./account-company-individual-quota-widget.vue?vue&type=script&lang=js&"
export * from "./account-company-individual-quota-widget.vue?vue&type=script&lang=js&"
import style0 from "./account-company-individual-quota-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports